import productUIStore from './productUIStore.js';
import productDataStore from './productDataStore.js';

export default {
  modules: {
    ui: productUIStore,
    data: productDataStore,
  },
};
